module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-non-bodymatter element-container-single element-type-also-by element-with-heading",
    attrs: {
      "epub:type": "z3998:published-works",
      "id": "also-by"
    }
  }, [_c('div', {
    staticClass: "heading heading-container-single heading-size-small heading-format-reduced heading-alignment-flexible heading-without-image"
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-without-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "element-title case-upper"
  }, [_vm._v("ALSO BY ROB SINCLAIR")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "id": "also-by-text"
    }
  }, [_c('p', {
    staticClass: "first first-in-chapter first-full-width also-by-content"
  }, [_c('b', [_c('span', {
    staticClass: "underline"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("Ryker Returns Series")])])])]), _vm._v(" "), _c('p', {
    staticClass: "subsq also-by-content"
  }, [_c('span', {
    staticClass: "content-external-link"
  }, [_vm._v("Renegade")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq also-by-content"
  }, [_c('span', {
    staticClass: "content-external-link"
  }, [_vm._v("Assassins")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq also-by-content"
  }, [_c('span', {
    staticClass: "content-external-link"
  }, [_vm._v("Outsider")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq also-by-content"
  }, [_c('a', {
    staticClass: "content-external-link",
    attrs: {
      "href": "https://geni.us/VigilanteRS",
      "target": "_blank"
    }
  }, [_vm._v("Vigilante")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq also-by-content"
  }, [_c('span', {
    staticClass: "content-external-link"
  }, [_vm._v("Protector")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq also-by-content"
  }, [_c('span', {
    staticClass: "content-external-link"
  }, [_vm._v("Deception")])]), _vm._v(" "), _c('div', {
    staticClass: "ornamental-break"
  }, [_c('div', {
    staticClass: "ornamental-break-block ornamental-break-aspect-wide"
  }, [_c('div', {
    staticClass: "ornamental-break-size-container ornamental-break-width-281"
  }, [_c('img', {
    staticClass: "ornamental-break-image",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "images/break-rule-screen.png"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width also-by-content"
  }, [_c('b', [_c('span', {
    staticClass: "underline"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("James Ryker Series")])])])]), _vm._v(" "), _c('p', {
    staticClass: "subsq also-by-content"
  }, [_c('span', {
    staticClass: "content-external-link"
  }, [_vm._v("The Red Cobra")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq also-by-content"
  }, [_c('span', {
    staticClass: "content-external-link"
  }, [_vm._v("The Black Hornet")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq also-by-content"
  }, [_c('span', {
    staticClass: "content-external-link"
  }, [_vm._v("The Silver Wolf")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq also-by-content"
  }, [_c('span', {
    staticClass: "content-external-link"
  }, [_vm._v("The Green Viper")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq also-by-content"
  }, [_c('span', {
    staticClass: "content-external-link"
  }, [_vm._v("The White Scorpion")])]), _vm._v(" "), _c('div', {
    staticClass: "ornamental-break"
  }, [_c('div', {
    staticClass: "ornamental-break-block ornamental-break-aspect-wide"
  }, [_c('div', {
    staticClass: "ornamental-break-size-container ornamental-break-width-281"
  }, [_c('img', {
    staticClass: "ornamental-break-image",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "images/break-rule-screen.png"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width also-by-content"
  }, [_c('b', [_c('span', {
    staticClass: "underline"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("The Enemy Series")])])])]), _vm._v(" "), _c('p', {
    staticClass: "subsq also-by-content"
  }, [_c('a', {
    staticClass: "content-external-link",
    attrs: {
      "href": "https://geni.us/DanceWithTheEnemyRS",
      "target": "_blank"
    }
  }, [_vm._v("Dance with the Enemy")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq also-by-content"
  }, [_c('a', {
    staticClass: "content-external-link",
    attrs: {
      "href": "https://geni.us/RiseOfTheEnemy",
      "target": "_blank"
    }
  }, [_vm._v("Rise of the Enemy")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq also-by-content"
  }, [_c('a', {
    staticClass: "content-external-link",
    attrs: {
      "href": "https://geni.us/HuntForTheEnemyRS",
      "target": "_blank"
    }
  }, [_vm._v("Hunt for the Enemy")])]), _vm._v(" "), _c('div', {
    staticClass: "ornamental-break"
  }, [_c('div', {
    staticClass: "ornamental-break-block ornamental-break-aspect-wide"
  }, [_c('div', {
    staticClass: "ornamental-break-size-container ornamental-break-width-281"
  }, [_c('img', {
    staticClass: "ornamental-break-image",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "images/break-rule-screen.png"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width also-by-content"
  }, [_c('b', [_c('span', {
    staticClass: "underline"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("The Sleeper 13 Series")])])])]), _vm._v(" "), _c('p', {
    staticClass: "subsq also-by-content"
  }, [_vm._v("Sleeper 13")]), _vm._v(" "), _c('p', {
    staticClass: "subsq also-by-content"
  }, [_vm._v("Fugitive 13")]), _vm._v(" "), _c('p', {
    staticClass: "subsq also-by-content"
  }, [_vm._v("Imposter 13")]), _vm._v(" "), _c('div', {
    staticClass: "ornamental-break"
  }, [_c('div', {
    staticClass: "ornamental-break-block ornamental-break-aspect-wide"
  }, [_c('div', {
    staticClass: "ornamental-break-size-container ornamental-break-width-281"
  }, [_c('img', {
    staticClass: "ornamental-break-image",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "images/break-rule-screen.png"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width also-by-content"
  }, [_c('b', [_c('span', {
    staticClass: "underline"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("The DI Dani Stephens Series")])])])]), _vm._v(" "), _c('p', {
    staticClass: "subsq also-by-content"
  }, [_vm._v("The Essence of Evil")]), _vm._v(" "), _c('p', {
    staticClass: "subsq also-by-content"
  }, [_vm._v("The Rules of Murder")]), _vm._v(" "), _c('p', {
    staticClass: "subsq also-by-content"
  }, [_vm._v("Echoes of Guilt")]), _vm._v(" "), _c('p', {
    staticClass: "subsq also-by-content"
  }, [_vm._v("The Bonds of Blood")]), _vm._v(" "), _c('div', {
    staticClass: "ornamental-break"
  }, [_c('div', {
    staticClass: "ornamental-break-block ornamental-break-aspect-wide"
  }, [_c('div', {
    staticClass: "ornamental-break-size-container ornamental-break-width-281"
  }, [_c('img', {
    staticClass: "ornamental-break-image",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "images/break-rule-screen.png"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width also-by-content"
  }, [_c('b', [_c('span', {
    staticClass: "underline"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("Standalone Thrillers")])])])]), _vm._v(" "), _c('p', {
    staticClass: "subsq also-by-content"
  }, [_vm._v("Dark Fragments")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0550006e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/alsobyrobsinclair.vue
// module id = 72
// module chunks = 0